<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Combine Subject Marks</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" persistent-hint hint="Please select academic year" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            @change="getStandardCourse()"
                            color="#0F2027"
                            persistent-hint
                            hint="Please select standard"
                            dense
                            rounded
                            required
                            v-model="standard"
                            :items="standard_list"
                            item-text="standard"
                            item-value="standard_id"
                            label="Standard"
                            outlined
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="combine_crs_id"
                            item-value="c_id"
                            :items="crs_list"
                            item-text="course"
                            label="Comine Course"
                            outlined
                            persistent-hint
                            hint="Please select combine course"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="crs_id"
                            multiple
                            item-value="c_id"
                            :items="crs_list"
                            item-text="course"
                            label="Courses to be combined"
                            outlined
                            persistent-hint
                            hint="Please select course"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list" item-text="s_name" item-value="id" label="Semester" persistent-hint hint="Please select semester" @change="getAssType()"/>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required outlined rounded color="#0F2027" v-model="ass_type" :items="assessment_detail_list" item-text="assessmenttype" item-value="id" label="Assessment Type" persistent-hint hint="Please select AssesmentType" />
                    </v-col>
                    <v-col cols="12" sm="2" class="pt-5" v-if="sem && standard && crs_id!='' && combine_crs_id && ass_type">
                        <v-btn class="button" @click="getCombinedMarks()" :loading="loader">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
             <v-card class="box" v-if="learner_info!=''" >
                  <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Combine Subject Marks Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                <v-simple-table fixed-header  dense height="500px" class="elevation-1">
                    <thead>
                        <tr>
                            <td>Registration No.</td>
                            <td >Name</td>
                            <td>Division</td>
                            <td v-for="(m,index1) in ass_details_for_marksheet" :key="index1">
                               <center>{{m}}</center>
                            </td>
                          
                            <td>
                                <center> Total Marks</center>
                            </td>
                            <td>
                                <center> Out Off Marks</center>
                            </td>
                             <td>
                                <center>Save / Update</center>
                            </td>
                        </tr>
                    </thead>
                     <tbody style="overflow-y: scroll;">
                        <tr v-for="(c,index) in learner_info" :key="index">
                            <td>{{c.reg_no}}</td>
                            <td>{{c.name}}</td>
                            <td>{{c.div}}</td>
                            <td v-for="(m,index1) in c.assement_type" :key="index1"><center>{{m}}</center></td>
                            <td>{{c.total_crs_marks}}</td>
                            <td>{{c.total_out_off_marks}}</td>
                            <td>
                                 <v-btn small class="button" :loading="save_single_loader" @click="saveSingleCombineMarks(c)">Save / Update </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
                </v-col>
                <center>
                    <v-btn class="button" @click="saveCombinedMarks(learner_info)" :loading="save_loader">Save / Update </v-btn>
                </center>
             </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            delete_attach_load: false,
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_list: [],
            ay: "",
            standard_list: [],
            standard: [],
            open_house_list: [],
            semester_list: [],
            semester: "",
            sem: null,
            course_list: [],
            crs_id: [],
            search: "",
            crs_list: [],
            assessment_detail_list:[],
            ass_type:null,
            combine_crs_id: null,
            learner_info:[],
            save_loader:false,
            save_single_loader:false,
            ass_details_for_marksheet:[],
        }),
        methods: {
            saveSingleCombineMarks(learner_info){
                const data = {
                    ay: this.ay,
                    standard: this.standard,
                    semester: this.sem,
                    combine_crs_id: this.combine_crs_id,
                    learner_info:learner_info,
                    crs_id: this.crs_id,
                    ass_type:this.ass_type
                }; 
                this.save_single_loader = true
                 axios
                    .post("/Examination/saveSingleCombineMarksV2", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.showSnackbar("#4caf50", "Marks Save / Updated Successfully...");
                            this.save_loader = false;
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.save_single_loader = false;
                    })
                    .finally(() => {
                        this.save_single_loader = false;
                    });
            },
            saveCombinedMarks(learner_info){
                const data = {
                    ay: this.ay,
                    standard: this.standard,
                    semester: this.sem,
                    combine_crs_id: this.combine_crs_id,
                    learner_info:learner_info,
                    crs_id: this.crs_id,
                    ass_type:this.ass_type
                };
                this.save_loader = true
                 axios
                    .post("/Examination/saveCombinedMarksV2", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.showSnackbar("#4caf50", "Marks Save / Updated Successfully...");
                            this.save_loader = false;
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.save_loader = false;
                    })
                    .finally(() => {
                        this.save_loader = false;
                    });
            },
            getCombinedMarks() {
                this.learner_info = []
                this.ass_details_for_marksheet =[]
                const data = {
                    ay: this.ay,
                    standard: this.standard,
                    semester: this.sem,
                    combine_crs_id: this.combine_crs_id,
                    crs_id: this.crs_id,
                    ass_type:this.ass_type
                };
                this.loader = true;
                axios
                    .post("/Examination/getCombinedMarksV2", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_info = res.data.learner_info
                            this.ass_details_for_marksheet = res.data.ass_details_for_marksheet
                            this.loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            onLoad() {
                axios
                    .post("/Examination/openHouse")
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay), (this.standard_list = res.data.standard_list), (this.open_house_list = res.data.open_house_list);
                            this.semester_list = res.data.semester_list;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            getStandardCourse() {
                const data = {
                    ay: this.ay,
                    standard: this.standard,
                };
                axios
                    .post("/Examination/getStandardCourse", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list = res.data.courses_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered for this standard..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getAssType() {
                axios
                    .post("/Examination/getAssType")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_detail_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: small !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
</style>
